import Toolbar from './Toolbar'

export default {
  name: 'toolbar',
  configure(config) {
    config.addComponent('toolbar', Toolbar)
  },
  Toolbar
}
